import prisonSelect from './index.vue';

var Plugin = {
  install: function install(Vue) {
    Vue.component('prison-select', prisonSelect);
  }
};
export { prisonSelect };
export default Plugin;


//////////////////
// WEBPACK FOOTER
// ./src/component/prison-select/index.js
// module id = 1
// module chunks = 0